import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

// Scroll-triggered fade + slide-up reveal wrapper.
export const Reveal = ({ children, delay = 0, y = 30, className = "", testId }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <motion.div
      ref={ref}
      data-testid={testId}
      className={className}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
};
